import React from 'react'

export const MessageOnLabel = ({ text = "*" }) => <span className='text-red-600 font-extrabold text-md'>{text}</span>

export const MessageUnsigned = ({ text = "(no asignado)" }) => <span className='text-red-700 font-bold text-sm'>{text}</span>
